export default
{
  nav: {
    'shipping-locale': 'Sprache',
  },
  titles: {
    default: 'Salvi Music Online-Shop',
    profile: 'Ihre Profil',
    orders: 'Ihre Bestellung',
    addresses: 'Ihre Anschrift',
    coupons: 'Ihre Gutscheine',
    configurator: 'Konfigurator',
    checkout: 'Checkout',
  },
  profile: {
    profile: 'Mein Profil',
    greeting: 'Hallo',
    orders: 'Meine Bestellungen',
    data: 'Meine Daten',
    addresses: 'Adressen',
    coupons: 'Gutscheine',
    logout: 'Abmelden',
  },
  userData: {
    myData: 'MEINE DATEN',
    complete: 'Profil bearbeiten',
    private: 'Privat',
    company: 'Unternehmen',
    birthday: 'Geburstag',
    job: 'Job',
    vat: 'MwSt.Nummer',
    language: 'Sprache',
    changeLanguage: 'Sprache ändern',
    myHarps: 'Meine Harfen',
    newHarp: 'Neue Harfen',
    addHarp: 'Harfe hinzufügen',
    chooseHarp: 'Harfe auswählen',
    accessData: 'ZUGANGSDATEN',
    save: 'Speichern',
    cancel: 'Abbrechen',
    cannotChange: 'Sie können Ihre Profil nicht ändern, da Ihr Wahrenkorb voll ist.',
    createNew: 'Erstellen Sie ein neues Profil, um Bestellungen für einen anderen Benutzertyp aufzugeben',
    haveHarps: 'Haben Sie eine oder mehrere Harfen?',
    addHarps: 'Hier einfügen um den Konfigurator einzustellen',
    close: 'Schließen',
    dateFormatPlaceholder: 'TT.MM.JJJJ',
    dateFormat: 'dd.MM.yyyy',
  },
  addresses: {
    sameAs: 'Gleiche Rechnungsadresse',
    addMore: 'Weitere Lieferadresse',
    areYouSure: 'Wirklich Ihre Adresse löschen?',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Adresse ändern',
    add: 'Adresse hinzufügen',
  },
  addressForm: {
    firstname: 'Vorname',
    lastname: 'Nachname',
    co: 'C/O',
    street: 'Straße',
    number: 'Nummer',
    postcode: 'PLZ',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    phone: 'Telefonnummer',
    note: 'Bemerkung',
    save: 'Speichern',
    taxNumber: 'Tax Number',
    taxNumberBracket: '(mandatory only for Italian citizens)',
    taxNumberMessage: 'The tax code does not correspond to the code of a physical person. If you are a private company, please contact support by email.',
  },
  password: {
    changePassword: 'Passwort ändern',
    old: 'Altes Passwort',
    new: 'Neues Passwort',
    newConfirm: 'Passwort bestätigen',
    savePassword: 'Passwort speichern',
  },
  payments: {
    stripe: 'Kreditkarte',
    paypal: 'PayPal',
    'paypal-msg': 'Sie werden zur Paypal-Website weitergeleitet',
    'stripe-msg': 'Bearbeitung der Zahlung...',
    'sepa-msg': 'Bearbeitung der Zahlung...',
    'sofort-msg': 'Sie werden zur Sofort-Website weitergeleitet',
    sepa: 'Sepa Direct Debit',
    sofort: 'SOFORT',
    cash: 'Cash on Delivery',
  },
  shipping: {
    'shipping-to': 'Versand an:',
    express: 'Express',
    standard: 'Standard',
    waiter: 'warten Sie, bitte',
  },
  checkout: {
    header: 'Check-out',
    'billing-address': 'Rechnungsadresse',
    'shipping-address': 'Lieferadresse',
    'shipping-addresses': 'Lieferadresse',
    'first-name': 'Vorname',
    'last-name': 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    country: 'ein Land auswählen',
    city: 'Stadt',
    address: 'Str.',
    no: 'Hausnummer',
    zip: 'PLZ',
    'shipping-to': 'Versand an:',
    'payment-method': 'Zahlungskondition:',
    summary: 'Übersicht',
    'order-btn': 'Bestellung abschließen',
    workingOn: 'Ihre Bestellung ist in Bearbeitung...',
    processing: 'Verarbeitung ...',
    'order-placed': 'Ihr Einkauf wurde gespeichert',
    selectAddress: 'Wählen Sie eine Lieferadresse:',
    changeAddress: 'Ausgewählte Adresse ändern',
    addAddress: 'Adresse hinzufügen',
    comeBack: 'Zurück zum Checkout',
    'delay-message': 'Wenn Sie diese Zahlungsart wählen, kann die Lieferzeit länger sein. Vor der vollständigen Erfüllung der Bestellung warten wir auf den Zahlungseingang (von 2 bis 6 Tagen).',
    'cash-message1': 'This payment method carries a fee of',
    'cash-message2': 'in addition to the order total.',
    commission: 'Fee',
    coupon: 'Gutschein',
    'discounted-total': 'Ermäßigter Gesamtbetrag',
    'discounted-subtotal': 'Ermäßigter Zwischensumme',
  },
  locale: {
    language: 'Sprache:',
  },
  catalog: {
    'view-all': 'Alle anzeigen',
    'search-acc': 'Zubehör suchen',
    'search-str': 'Finde deine Saite',
    octaves: 'Oktaven',
    strings: 'Saiten',
    brands: 'Marken',
    str: 'Saiten',
    acc: 'Zubehör',
    subcategory: 'Subcategory',
    brand: 'Marken',
  },
  menu: {
    'configurator-string': 'Saitenkonfigurator',
    search: 'Suchen',
    account: 'Mein Konto',
    cart: 'Warenkorb',
    'shipping-locale': 'Sprache ändern',
  },
  login: {
    enter: 'Einloggen',
    'pw-forgot': 'Password vergessen?',
    new: 'Neuer Kunde?',
    register: 'Anmelden',
    verify: 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
    welcome: 'Willkommen zurück, ',
    logout: 'Abmeldung',
  },
  signin: {
    title: 'Anmelden oder einloggen zu Salvi Music',
    register: 'Anmelden',
    login: 'Einloggen',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'Email',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    receive: 'Haben Sie die E-Mail nicht bekommen?',
    resend: 'E-Mail erneut senden',
    vatsMessage: 'Wenn Sie sich als juristische Personen (Schulen, Vereine, Mwst.-Inhaber) auf dieser Seite registrieren lassen wollen, schreiben Sie uns bitte an diese E-Mail-Adresse: ',
  },
  carousel: {
    title1: 'PROBIEREN SIE DEN NEUEN SAITENKONFIGURATOR AUS',
    title2: 'SÄMTLICHES ZUBEHÖR FÜR IHRE HARFE',
    discover: 'Suchen',
  },
  product: {
    vat: 'inklusive MwSt., ohne Versand',
    shipping: 'Kostenloser Versand',
    payment: 'Sichere Bezahlung',
    returns: 'Rücksendung & Rückerstattung',
    details: 'Produktinformationen',
    'shop-by': 'Kaufen nach',
    brand: 'Marken',
    price: 'Preis',
    shop: 'Kaufen',
    strings: 'Saiten',
    string: 'Saiten',
    accessories: 'Zubehör',
    delivery: 'Versand und Lieferung',
    material: 'Material:',
    octave: 'Oktave:',
    note: 'Note:',
    quantity: 'Anzahl:',
    'orders-over': 'Für Bestellungen über 150€',
    'free-delivery': 'Kostenloser Versand ab einem Einkaufswert von mindestens 150€. Der kostenloser Versand gilt automatisch, sobald der Betrag erreicht ist.',
    addToCart: 'In den Warenkorb',
    addedToCart: 'Produkt im Warenkorb',
    alt: 'Bild für',
    widget: 'Produktkarte',
    addToCartOctave: 'Oktave in den Warenkorb',
    addToCartLayout: 'Saiten in den Warenkorb',
    searchingStrings: 'Sie durchsuchen die Saiten',
    outOfStock: 'Ausverkauft',
    noVat: 'VAT excluded, Shipping excluded',
    notAvailable: 'Derzeit nicht verfügbar',
    categories: 'Kategorien',
    sheet: 'Noten',
    cd: 'Aufnahmen & CDs',
    onRequest: 'Auf Anfrage',
    onRequestMessage: 'Fragen Sie diesen Artikel per E-Mail mit einem einfachen Klick an. Der Artikel ist zur Zeit nicht auf Lager, die Lieferzeit verlängert sich (um ca. 2 Wochen).',
    onRequestAreYouSending: 'Sie senden eine Bestellanfrage für das Produkt:',
  },
  string: {
    family: 'Kategorie:',
    material: 'Material:',
    octave: 'Oktave:',
    note: 'Note:',
  },
  orders: {
    number: 'Bestellnummer',
    date: 'Bestelldatum',
    amount: 'Bestellbetrag',
    status: 'Bestellstatus',
    'status-in_work': 'In Arbeit',
    'status-shipped': 'Ausgeliefert',
    'status-new': 'Neu',
    'status-registered': 'Registriert',
    'status-pending': 'Ausstehend',
    'status-failed_payment': 'Zahlung fehlgeschlagen',
  },
  order: {
    details: 'Bestelldetails',
    'invoice-link': 'Rechnung einsehen',
    'status-processed': '1. Bearbeitet',
    'status-transit': '2. Unterwegs',
    'status-delivered': '3. Ausgeliefert',
    number: 'Bestellnummer',
    date: 'Bestelldatum',
    'billing-address': 'Rechnungsadresse',
    'shipping-address': 'Lieferadresse',
    'shipping-method': 'Vesandart',
    'payment-method': 'Zahlungsmethode',
    summary: 'Übersicht',
    description: 'Beschreibung',
    code: 'Code',
    product: 'Produkt',
    qty: 'Anzahl',
    amount: 'Betrag',
    back: 'Zurück',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    total: 'Gesamtsumme',
    'inc-vat': 'inkl. MwSt.',
    'tracking-info': 'Tracking Information',
    'tracking-sentence': 'Überprüfen Sie den Status Ihres Versands ',
    'tracking-here': 'Hier',
    pending: 'Bestellung ausstehende Zahlung.',
    pay: 'Bezahlen',
    message: 'Wenn die Zahlung nicht innerhalb einer Woche erfolgt, wird diese Bestellung storniert.',
    noVat: 'excl. VAT',
    shippingNational: 'Price for national shipping',
    shippingAbroad: 'Price for international shipping',
    waitingConfirm: 'Auf Zahlungsbestätigung warten',
  },
  configurator: {
    title: 'SAITENKONFIGURATOR',
    subtitle: 'Der schnellste und einfachste Weg, die richtige Saite zu finden',
    chooseHarp: 'Wählen Sie eine Harfe',
    selectOctave: 'Oktave auswählen',
    selectNote: 'Note auswählen',
    selectMaterial: 'Material auswählen',
    strings: 'Saiten',
    seeMore: 'Weitere Harfen',
    seeYours: 'Sehen Sie Ihre Harfen',
    octave: 'Oktave',
    note: 'Note',
    description: 'Description',
    price: 'Preis',
    reset: 'Reset configurator',
    lever: 'Hakenharfen',
    pedal: 'Pedalharfen',
    electric: 'Electric',
    electroacustic: 'Electroacustic',
    'professional lever': 'Professional lever',
    'student lever': 'Student lever',
    premium: 'Premium',
    'professional pedal': 'Professional pedal',
    'student pedal': 'Student pedal',
    'lever gut': 'Lever Gut',
    'pedal gut': 'Pedal Gut',
    silkgut: 'Silkgut',
    biocarbon: 'BioCarbon',
    KF: 'Carbon',
    workInProgress: 'Der SaitenKonfigurator ist in Arbeit',
    comeBack: 'Wenn Sie Ihre Harfenkonfiguration nicht finden können, versuchen Sie, in ein paar Tagen wiederzukommen.',
  },
  footer: {
    terms: 'Allgemeine Geschäftsbedingungen',
    shipping: 'Liefer- und Zahlungsbedingungen',
    about: 'Über uns',
    shop: 'Shop',
    contact: 'Kontakt',
    newsletter: 'Abonnieren Sie den Newsletter',
    signup: 'Abonnieren',
    'customer-service': 'Kundenservice',
    cookie: 'Cookies und Datenschutzerklärung',
    'privacy-newsletter': 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen und erhalte den Newsletter.',
    'cookie-banner': '🍪 Wir nutzen Coookies. Mehr erfahren Sie ',
    here: 'hier',
    'cookie-button': 'Got it!',
    logos: 'Logos',
    socialLogos: 'Logos sozialer Netzwerke',
    paymentLogos: 'Zahlungs-Logos',
    email: 'Email',
    newsletterTitle: 'Newsletter',
    imprint: 'Impressum',
  },
  error: {
    404: 'Fehler 404',
    page: 'UH OH! Haben Sie sich verlaufen?',
    phrase: 'Seite nicht gefunden. Wie Sie hierhergekommen sind, ist es ein Geheimnis. Sie können jedoch auf die Taste unten klicken, um zur Startseite zurückzukehren.',
    503: 'Wir sind bald zurück!',
    'phrase-503': 'Die Website wird derzeit gewartet, aber wir werden bald wieder online sein. Versuchen Sie es später noch einmal!',
  },
  cart: {
    cart: 'Warenkorb',
    clear: 'Warenkorb löschen',
    total: 'Gesamtsumme',
    subtotal: 'Zwischensumme',
    shippingCalculate: 'Versand beim Checkout berechnen',
    shipping: 'Versand',
    vat: 'inkl. MwSt.',
    checkout: 'Checkout',
    emptyCart: 'Der Warenkorb ist leer.',
    noVat: 'Excl. VAT',
    shippingNational: 'Price for national shipping',
    shippingAbroad: 'Price for international shipping',
    heavyShipping: 'The shipping price varies based on the weight of the selected items',
  },
  notifications: {
    error: 'Fehler:',
    failedReadingProduct: 'Ausgewähltes Produkt nicht gelesen:',
    credentialsInvalid: 'Die angegebenen Zugangsdaten sind ungültig.',
    successfulLogin: 'Erfolgreich eingeloggt!',
    noMoreLoggedIn: 'Sie sind night eingeloggt!',
    changeLocale: 'Fehler bei der Spracheinstellung:',
    harpsReading: 'Harfe nicht erkannt',
    updateLocale: 'Sprache erfolgreich aktualisiert',
    saveAddress: 'Adresse erfolgreich aktualisiert',
    editAddress: 'Adresse erfolgreich bearbeitet',
    removeAddress: 'Adresse erfolgreich gelöscht',
    addHarp: 'Harfe erfolgreich hinzugefügt',
    removeHarp: 'Harfe erfolgreich gelöscht',
    updatePassword: 'Passwort erflogreich aktualisiert',
    registration: 'Registration erfolgreich',
    contact: 'Email erfolgreich zu info@salvimusic.de gesendet',
    chooseHarp: 'Harfe auswählen',
    errorTryAgain: 'Fehler. Bitte wiederholen.',
    expiredSession: 'Abgelaufene Sitzung. Bitte einloggen',
    errorReload: 'Es gibt einen Fehler. Bitte laden Sie die Seite neu',
    errorPayment: 'Es gibt einen Zahlungsfehler, bitte versuchen Sie es erneut',
    whyDiscount: 'Sie haben Anspruch auf diesen Rabatt als ',
    outOfStockFirst: 'Das Produkt',
    outOfStockSecond: 'wurde aus Ihrem Warenkorb entfernt, da es derzeit nicht auf Lager ist.',
    noStringsLayout: 'Das angeforderte Saitenlayout ist noch nicht verfügbar',
    emailSendAgain: 'Wir senden Ihnen eine neue E-Mail',
    newsletterAccept: 'Bitte akzeptieren Sie die Datenschutzbestimmungen',
    newsletterSend: 'Wir haben Ihnen eine E-Mail zur Bestätigung der Newsletter-Anmeldung geschickt',
    onRequestEmail: 'Die Anfrage E-Mail wurde gesendet',
  },
  contacts: {
    title: 'Kontakt',
    'opening-hours': 'Öffnungszeiten:',
    showroomPhone: 'Telefonnummer:',
    showroomEmail: 'Email:',
    firstShowroom: {
      name: 'Remagen Showroom',
      address: 'Mainzer Straße, 28 - 53424 Remagen',
      time: 'Öffnungszeiten: Montag bis Freitag von 9:00 bis 17:00',
      phone: 'Telefonnummer: 02228.8093',
      email: 'Email: info@salvimusic.de',
    },
    secondShowroom: {
      name: 'Berlin Showroom',
      address: 'Schloßstraße, 66 - 14059 Berlin',
      time: 'Öffnungszeiten: Montag bis Freitag von 9:30 bis 17:30',
      phone: 'Telefonnummer: 030.37025222',
      email: 'Email: info@salvimusic.de',
    },
    contactUs: 'Kontaktieren Sie uns',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'Email',
    phone: 'Telefonnummer',
    message: 'Nachricht',
    send: 'Anfrage senden',
  },
  paginate: {
    previous: 'Zurück',
    next: 'Weiter',
  },
  stripe: {
    data: 'Zahlungsdaten',
    holder: 'Karteninhaber',
    save: 'Zahlungsmethode sichern',
    add: 'Neue Karte hinzufühgen',
    enterPaymentMethod: 'Bitte geben Sie eine gültige Zahlungsmethode ein',
    authRequired: 'Authentifizierung zur Autorisierung der Zahlung erforderlich',
    expiry: 'Ablauf:',
    mine: 'Meine Zahlungskonditionen',
  },
  cards: {
    cards: 'Meine Karten',
    areYouSure: 'Sind Sie sicher, dass Sie diese Zahlungsmethode löschen möchten?',
    irreversible: 'Nicht umkehrbarer Vorgang',
    delete: 'Löschen',
    cancel: 'Stornieren',
    expired: 'ABGELAUFEN!',
    last: 'Ihre letzte Zahlungsmethode',
    seeAll: 'Alle Karten anzeigen',
    close: 'Schließen',
  },
  iban: {
    seeAll: 'Alle Iban anzeigen',
    close: 'Schließen',
    add: 'Neue Iban hinzufühgen',
    save: 'Iban sichern',

  },
  input: {
    fillField: 'Füllen Sie dieses Feld aus',
  },
  metaDescriptions: {
    homepage: 'Willkommen beim Salvi Music Online SHOP, Ihrem Onlineshop, der alle Arten von Zubehör und Saiten für Ihre Harfe anbietet. Wir bieten Qualität zum besten Preis.',
    about: 'Salvi Music Online SHOP bedient Anfänger sowie professionelle Harfenisten mit Engagement, Service und Produktkenntnis über ihre Auswahl an Haken- und Pedalharfen, Noten, Saiten und Zubehör.',
    configurator: 'Jede Saite für Ihre Harfe! Mit unserem schnellen System schlägt Ihnen der Konfigurator mit einem einfachen Klick alles vor, was Sie brauchen.',
    categoryCatalogs: 'In unserem Katalog finden Sie alle Saiten, für Haken- und Pedalharfen, der besten Marken wie Bow Brand, Pirastro, Sipario, und das gesamte Zubehör für Ihre Harfe: Transporthüllen, Transportwägen, Notenständer, Sitzbänke, Notenständer, Stimmschlüssel und mehr…',
    brandCatalogs: 'Wir bieten einen kompletten Katalog für die gesamte Salvi Harps, Lyon & Healy, BowBrand und Sipario Kollektionen. Klicken Sie hier, um mehr zu erfahren...',
    account: 'Holen Sie das Beste aus den Optionen Ihres Kundenkontos heraus: Überprüfen Sie Ihren Bestellstatus, verwenden Sie Ihre Gutscheine, speichern und bearbeiten Sie Ihre Angaben',
    orders: 'Geben Sie einfach Ihre Bestellung auf und überprüfen Sie Ihren Bestellstatus jederzeit mit einem einfachen Klick…',
    addresses: 'Rechnungs- und Lieferadresse, einfache Verwaltung Ihrer Adressen, hinzufügen, bearbeiten und löschen...',
    coupons: 'Prüfen Sie hier Ihre Coupons, überraschende Rabatte nur für Sie!',
    checkout: 'Sie können sicher und schnell bezahlen, indem Sie Ihre bevorzugte Methode wählen! Mehr erfahren…',
    singleOrder: 'Unter Meine Bestellungen können Sie Ihre Bestellübersicht, den Versandstatus und Details einsehen, indem Sie einfach Ihre Registrierungsdaten angeben.',
    terms: 'Sehen Sie sich die vollständigen Bedingungen für den Einkauf im Salvi Music Online SHOP an, einschließlich Zahlung, Lieferung, Rückgabe und mehr.',
    return: 'Wir sind gern bereit, jeden gekauften Artikel innerhalb von 30 Tagen nach dem Kauf umzutauschen oder zu erstatten. Erfahren Sie mehr...',
    shipping: 'Noch nie war es so günstig! Nur 2 EUR pro Lieferung, kostenloser Versand bei Bestellungen über 150 EUR.',
    contacts: 'Haben Sie eine Frage oder brauchen Sie Hilfe? In ganz Europa sind wir in Ihrer Reichweite. Hier finden Sie unsere Showrooms und Kontaktdaten für die beste Unterstützung.',
  },
  productAttributes: {
    material: 'Material',
    octave: 'Octave',
    note: 'Note',
    silkgut: 'Silkgut',
    'silkgut copper': 'Silkgut Copper',
    biocarbon: 'BioCarbon',
    kf: 'KF',
    'lever gut': 'Lever gut',
    'pedal gut': 'Pedal gut',
    'lever wire': 'Lever wire',
    'pedal wire': 'Pedal wire',
    'lever nylon': 'Lever nylon',
    'pedal nylon': 'Pedal nylon',
    'polyester/polyurethane': 'Polyester/Polyurethane',
    velvet: 'Velvet',
    satin: 'Satin',
    'eco fabric': 'Eco Fabric',
    'steel/rubber': 'Steel / Rubber',
    leather: 'Leather',
    cordura: 'Cordura',
    wood: 'Wood',
    steel: 'Steel',
    polyester: 'Polyester',
    'leather, nylon': 'Leather, nylon',
    wire: 'Wire',
    alluminium: 'Alluminium',
    'nylon/polyurethane': 'Nylon/Polyurethane',
    'cotton/vinyl': 'Cotton / Vinyl',
    felt: 'Felt',
  },
  coupons: {
    apply: 'Anwenden',
    validCode: 'gültiger Gutschein',
    noSelected: 'Kein Gutschein ausgewählt',
    hasACoupon: 'Haben Sie einen Gutschein?',
    invalid: 'Der eingegebene Gutschein ist ungültig oder wurde bereits verwendet',
    code: 'Gutschein',
    description: 'Beschreibung',
    value: 'Wert',
    uses: 'Anzahl der Nutzungen',
    expiration: 'Verfallsdatum',
    exhaustion: 'bis zur Ausschöpfung',
    used: 'Gutschein verwendet',
    totalWithoutCoupon: 'Gesamtbetrag ohne Gutschein',
    totalPaid: 'Ermäßigter Gesamtbetrag',
    writeCoupon: 'Schreiben Sie den Gutscheincode:',
    chooseCoupon: 'Oder wählen Sie einen Ihrer Gutscheine aus:',
    expired: 'Verfallen',
    noCoupons: 'Sie haben derzeit keine Gutscheine.',
  },
  filters: {
    clear: 'Filter löschen',
    brand: 'Marke',
    subcategory: 'Subcategory',
    noProducts: 'Es gibt keine Produkte mit diesen Eigenschaften.',
    noComposers: 'Es gibt keine Gutscheine mit diesen Ziffern.',
    searchComposer: 'Komponist suchen',
  },
};
